import React, { useEffect, useState } from 'react';
import { getFooterHTML } from '../helpers';

const Footer = () => {
  const [footer, setFooter] = useState(getFooterHTML());

  useEffect(() => {
    const timer = setInterval(() => {
      const footerHtml = localStorage.getItem('footer_html');
      if (footerHtml) {
        setFooter(footerHtml);
      }
    }, 200);

    const stopTimer = setTimeout(() => clearInterval(timer), 1000);
    return () => {
      clearInterval(timer);
      clearTimeout(stopTimer);
    };
  }, []);

  if (!footer) return null;

  return (
    <footer className='app-footer'>
      <div
        className='app-footer-extra'
        dangerouslySetInnerHTML={{ __html: footer }}
      />
    </footer>
  );
};

export default Footer;
